import React from 'react';
import { Box, Typography, Divider, List, ListItem, ListItemText } from '@mui/material';

const ResultSummary = ({ result }) => {
  if (!result) return null;

  const {
    totalConsumption,
    totalCharge,
    subMeters,
    taxesByTypeId = {}
  } = result;

  return (
    <Box mt={4}>
      <Typography variant="h6" gutterBottom>Hesaplama Özeti</Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="body1">
        Toplam Tüketim: <strong>{totalConsumption?.toFixed(3)} kWh</strong>
      </Typography>
      <Typography variant="body1">
        Toplam Tutar: <strong>{totalCharge?.toFixed(2)} ₺</strong>
      </Typography>

      {Object.keys(taxesByTypeId).length > 0 && (
        <>
          <Typography variant="subtitle1" mt={2}>Vergiler</Typography>
          <List dense>
            {Object.entries(taxesByTypeId).map(([taxType, amount]) => (
              <ListItem key={taxType}>
                <ListItemText
                  primary={`${taxType}: ${amount.toFixed(2)} ₺`}
                />
              </ListItem>
            ))}
          </List>
        </>
      )}

      {subMeters && subMeters.length > 0 && (
        <>
          <Typography variant="subtitle1" mt={2}>Süzme Sayaç Paylaşımları</Typography>
          <List dense>
            {subMeters.map((sm, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={`Sayaç ID ${sm.subMeterId}`}
                  secondary={`Tüketim: ${sm.totalConsumption.toFixed(3)} kWh, Tutar: ${sm.totalCharge.toFixed(2)} ₺`}
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );
};

export default ResultSummary;
